import {useCallback, useEffect, useState} from 'react';
import {Linking} from 'react-native';
import {getShareInfo, updateInviteCode} from './share.service';
import globalStore from '@/services/global.state';
import {copyText, errorLog, goTo, openShare} from '@/utils';
import i18n from '@/i18n';
import {ShareInfo} from '@/components/business/share-panel/share-panel-provider';
import {envConfig} from '@/utils/env.config';

export function shareToPlatform(
  platform: string,
  link: string,
  tip: string = '',
) {
  if (!globalStore.token) {
    goTo('Login');
    return;
  }
  copyText(link);
  switch (platform) {
    case 'link':
    case 'CopyLink':
      globalStore.globalSucessTotal(i18n.t('share.copy-success'), tip);
      break;
    case 'Facebook':
      Linking.openURL('fb://messaging').catch(e => errorLog(e));
      break;
    case 'Telegram':
      Linking.openURL(`tg://msg_url?url=${encodeURIComponent(link)}`).catch(e =>
        errorLog(e),
      );
      break;
    case 'Whatsapp':
      Linking.openURL('https://wa.me?text=' + encodeURIComponent(link)).catch(
        e => errorLog(e),
      );
      break;
    case 'Instagram':
      Linking.openURL('instagram://media').catch(e => errorLog(e));
      break;
  }
}
const makeShareMessage = (msg: string) =>
  msg.replace(
    /https?:\/\/[^?]+/g,
    `${process.env.REACT_APP_SHARE_DOMAIN || ''}/invitation-apply`,
  );

export function useShare(autoInit = false) {
  const [code, setCode] = useState<string>('');
  const [invateText, setInviteText] = useState('');

  const copyCode = useCallback(() => {
    if (!globalStore.token) {
      goTo('Login');
      return;
    }
    copyText(code);
    globalStore.globalSucessTotal(i18n.t('share.copy-success'));
  }, [code]);

  /**
   * 进行分享
   * @param info
   *
   */
  const doShare = useCallback(
    (info: ShareInfo = {}) => {
      if (!globalStore.token) {
        goTo('Login');
        return;
      }
      const shareText = makeShareMessage(`${invateText}?code=${code}`);
      copyText(shareText);
      if (openShare(shareText)) {
        return;
      }
      info.info = shareText;
      globalStore.shareProviderSubject.next(info);
    },
    [code, invateText],
  );

  const doLegacyInviteShare = useCallback(
    (tip = '') => {
      if (!globalStore.token) {
        goTo('Login');
        return;
      }
      const shareText = makeShareMessage(`${invateText}?code=${code}`);
      copyText(shareText);
      globalStore.globalSucessTotal(i18n.t('share.copy-success'), tip);
      openShare(shareText);
    },
    [code, invateText],
  );

  const initShare = useCallback(() => {
    return getShareInfo().then(data => {
      setCode(data.inviteCode);

      // 如果配置了分享域名，则替换文本中的原有域名
      let shareText = data.inviteRegisterLinkUrl;
      setInviteText(shareText);
    });
  }, []);

  const refreshCode = useCallback(async () => {
    await updateInviteCode();
    await initShare();
  }, [initShare]);
  const shareGame = useCallback(
    (info: ShareInfo = {}) => {
      if (!globalStore.token) {
        goTo('Login');
        return;
      }
      const url =
        (location.origin?.includes('-pre')
          ? location.origin
          : envConfig.shareDomain) + '/scratch-share';
      const shareText = `${url}?code=${code}`;
      copyText(shareText);
      if (openShare(shareText)) {
        return;
      }
      info.info = shareText;
      globalStore.shareProviderSubject.next(info);
    },
    [code],
  );

  useEffect(() => {
    if (autoInit) {
      initShare();
    }
  }, [autoInit, initShare]);

  return {
    initShare,
    doShare,
    doLegacyInviteShare,
    code,
    refreshCode,
    copyCode,
    shareGame,
  };
}
